<template>
  <v-card tile class="py-0 rounded-0" :elevation="0">
    <v-container fluid class="pa-0">
      <v-container class="pa-0">
        <v-tabs show-arrows density="compact" v-model="activeTab">
          <div class="navrow">
            <template v-for="(menu, index) in rootMenus" :key="`root-${index}-${menu.NameUrl || 'home'}`">
              <MenuItemNavbar :menu="menu" basePath="/" :depth="1" />
            </template>
          </div>
        </v-tabs>
      </v-container>
    </v-container>
  </v-card>
</template>

<script setup>
import { useNuxtApp } from '#app'
import MenuItemNavbar from '@/components/App/MenuItemNavbar.vue'
const activeTab = ref(false)

onMounted(() => {
  activeTab.value = false
})

const { $methods } = useNuxtApp()
const dataAll = useDataAll()
const MenuPush = usePageOverviewStore().PageOverview;
const siteSettings = useSiteSettingsStore();

// Home menu item (prepend when allowed)
const homeMenuItem = {
  ShowHeadMenu: '1',
  NameMenu: 'Home',
  CodeParent: '',
  NameUrl: '',
  SubPage: []
}

const exists = MenuPush.some(
  i => i.NameMenu === homeMenuItem.NameMenu && i.NameUrl === homeMenuItem.NameUrl
)

if ( getYesNo(siteSettings, 'ShowHeadMenu') && !exists) {
  MenuPush.unshift(homeMenuItem)
}

// Only render true top-level items (CodeParent === '') that should be shown
const rootMenus = computed(() =>
  MenuPush.filter(
    i => (i.CodeParent ?? '') === '' && getYesNo(i, 'ShowHeadMenu')  && (i.NameMenu ?? '') !== ''
  )
)
</script>
